import { IAction, StateStatus } from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  nonMemberStateCountries: any;
  allCountriesList: any;
  importCountries: any;
  countiesExcludeCyprus: any;
  memberStateCountries: any;
  registrationDetail: any;
  temporarySaveStatus: any;
  finalSubmitStatus: any;
  fixedEstablishments: any;
  previousUseOfSpecialSchemes: any;
  identificationInOtherEuCountries: any;
  schemeTypesList: any;
  approveRegistrationStatus: any;
  rejectRegistrationStatus: any;
  updateRegistrationStatus: any;
  excludeRegistrationStatus: any;
  idTypeList: any;
  applicantActiveRegistrations: {
    status: StateStatus | any;
    data: any;
  };
}

const initialState: IState = {
  nonMemberStateCountries: {
    status: null,
    data: null,
  },
  importCountries: {
    status: null,
    data: null,
  },
  allCountriesList: {
    status: null,
    data: null,
  },
  countiesExcludeCyprus: {
    status: null,
    data: null,
  },
  memberStateCountries: {
    status: null,
    data: null,
  },
  registrationDetail: {
    status: null,
    data: null,
  },
  // submition types
  temporarySaveStatus: null,
  finalSubmitStatus: null,
  // registreation info
  fixedEstablishments: null,
  previousUseOfSpecialSchemes: null,
  identificationInOtherEuCountries: null,
  schemeTypesList: {
    status: null,
    data: null,
  },
  approveRegistrationStatus: null,
  rejectRegistrationStatus: null,
  updateRegistrationStatus: null,
  excludeRegistrationStatus: null,
  idTypeList: {
    status: null,
    data: null,
  },
  applicantActiveRegistrations: {
    status: null,
    data: null,
  },
};

const RegistrationDetailReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_REGISTRATION_DETAIL:
      return {
        ...state,
        registrationDetail: {
          ...state.registrationDetail,
          status: action.status,
          data: action.data.data,
        },
        fixedEstablishments: action.data.fixed_establish_details,
        previousUseOfSpecialSchemes:
          action.data.previous_use_of_special_schemes,
        identificationInOtherEuCountries:
          action.data.identification_in_other_countries,
      };
    case Types.SET_ALL_COUNTRIES:
      return {
        ...state,
        allCountriesList: {
          ...state.allCountriesList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_COUNTRIES_EXCLUDE_CYPRUS:
      return {
        ...state,
        countiesExcludeCyprus: {
          ...state.countiesExcludeCyprus,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_NON_MEMBER_STATE_COUNTRIES:
      return {
        ...state,
        nonMemberStateCountries: {
          ...state.nonMemberStateCountries,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_IMPORT_COUNTRIES:
      return {
        ...state,
        importCountries: {
          ...state.importCountries,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_MEMBER_STATE_COUNTRIES:
      return {
        ...state,
        memberStateCountries: {
          ...state.memberStateCountries,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_SCHEME_TYPES:
      return {
        ...state,
        schemeTypesList: {
          ...state.schemeTypesList,
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_PREVIOUS_USE_OF_SPECIAL_SCHEME:
      return {
        ...state,
        previousUseOfSpecialSchemes: action.data,
      };
    case Types.SET_IDENTIFICATION_IN_OTHER_EU_COUNTRIES:
      return {
        ...state,
        identificationInOtherEuCountries: action.data,
      };
    case Types.SET_FIX_ESTABLISHMENTS:
      return {
        ...state,
        fixedEstablishments: action.data,
      };
    case Types.TEMPORARY_SAVE_REGISTRATION:
      return {
        ...state,
        temporarySaveStatus: action.status,
      };
    case Types.FINAL_SUBMIT_REGISTRATION:
      return {
        ...state,
        finalSubmitStatus: action.status,
      };
    case Types.APPROVE_REGISTRATION:
      return {
        ...state,
        approveRegistrationStatus: action.status,
      };
    case Types.REJECT_REGISTRATION:
      return {
        ...state,
        rejectRegistrationStatus: action.status,
      };
    case Types.UPDATE_REGISTRATION:
      return {
        ...state,
        updateRegistrationStatus: action.status,
      };
    case Types.EXCLUDE_REGISTRATION:
      return {
        ...state,
        excludeRegistrationStatus: action.status,
      };
    case Types.SET_ID_TYPE:
      return {
        ...state,
        idTypeList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_APPLICANT_ACTIVE_REGISTRATIONS:
      return {
        ...state,
        applicantActiveRegistrations: {
          status: action.status,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default RegistrationDetailReducer;
